import { render, staticRenderFns } from "./RepaymentRemind.vue?vue&type=template&id=64920602&scoped=true&"
import script from "./RepaymentRemind.vue?vue&type=script&lang=ts&"
export * from "./RepaymentRemind.vue?vue&type=script&lang=ts&"
import style0 from "./RepaymentRemind.vue?vue&type=style&index=0&id=64920602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64920602",
  null
  
)

export default component.exports